import Container from './Container'
import { ContainerType } from './ContainerType'
import Device from '../Device'

export default class DockedRightContainer extends Container {
  constructor () {
    super(ContainerType.DOCKED_RIGHT, false)
  }

  supported () {
    return Device.isDesktop()
  }

  style (bid, slot, media) {
    const container = slot.container()

    container.style.display = 'flex'
    container.style['align-items'] = 'center'
    container.style['justify-content'] = 'center'
    container.style.position = 'fixed'
    container.style.top = '50%'
    container.style.right = '0px'
    container.style.transform = 'translate(0%, -50%)'
  }
}
